import { render, staticRenderFns } from "./Lungcancer503.vue?vue&type=template&id=7384ea1f&scoped=true&"
import script from "./Lungcancer503.vue?vue&type=script&lang=js&"
export * from "./Lungcancer503.vue?vue&type=script&lang=js&"
import style0 from "./Lungcancer503.vue?vue&type=style&index=0&id=7384ea1f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7384ea1f",
  null
  
)

export default component.exports